module.exports = __webpack_public_path__ + "static/shopify-6ee6c20b9ea8b43c06bb7330382bbf8c.svg";